import { Center, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import './search-loading.css';

export const SEARCH_LOADING_MESSAGES = [
  'Consulting the records…',
  'Decrypting securely…',
  'Examining the evidence…',
  'Scanning the archives…',
  'Triaging your results…',
  'Putting the kettle on…',
  'Asking the database nicely…',
] as const;

/**
 * Loading state for the slow server-side searches. Shows an on-brand
 * dermatoscope-sweep animation with a rotating, gently-witty status message.
 * Fades in after ~250ms so fast responses never flash it; freezes the sweep
 * under prefers-reduced-motion (the message still rotates).
 */
export function SearchLoading() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % SEARCH_LOADING_MESSAGES.length);
    }, 1700);
    return () => clearInterval(id);
  }, []);

  return (
    <Center mih={200}>
      <Stack align="center" gap="sm" className="sa-root">
        <svg width="140" height="96" viewBox="0 0 140 96" aria-hidden="true" fill="none">
          <rect
            x="26"
            y="18"
            width="88"
            height="60"
            rx="7"
            fill="var(--mantine-color-gray-1)"
            stroke="var(--mantine-color-gray-3)"
            strokeWidth="1"
          />
          <circle cx="44" cy="36" r="7" fill="var(--mantine-color-gray-5)" />
          <rect x="58" y="32" width="44" height="5" rx="2.5" fill="var(--mantine-color-gray-4)" />
          <rect x="40" y="52" width="60" height="4" rx="2" fill="var(--mantine-color-gray-3)" />
          <rect x="40" y="62" width="42" height="4" rx="2" fill="var(--mantine-color-gray-3)" />
          <g className="sa-sweep">
            <line
              x1="70"
              y1="8"
              x2="70"
              y2="88"
              stroke="var(--mantine-color-teal-6)"
              strokeWidth="1.25"
              opacity="0.5"
            />
            <circle
              cx="70"
              cy="48"
              r="15"
              fill="none"
              stroke="var(--mantine-color-teal-6)"
              strokeWidth="3"
            />
            <line
              x1="80"
              y1="58"
              x2="90"
              y2="68"
              stroke="var(--mantine-color-teal-6)"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </g>
        </svg>
        <Text role="status" aria-live="polite" c="dimmed" size="sm">
          {SEARCH_LOADING_MESSAGES[index]}
        </Text>
      </Stack>
    </Center>
  );
}
